export const calculateDynamicStyle = (width) =>
  width
    ? {
        minWidth: `${width}px`,
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
      }
    : {};
